const state = {
  tennants: {
    isLoading: false,
    many: {},
    one: null,
  },
};

export default state;
